import ajax from '../http/ajax'

export const getAllStoreList = data => {
    return ajax.get('getAllStoreList', data)
}

export const getNearbySstores = data => {
    return ajax.get('getNearbySstores', data)
}

export const getClosestSstores = data => {
    return ajax.get('getClosestSstores', data)
}
